import axios from "axios";
import { ENDPOINTS } from "../endpoints";
import baseURL from "../../config";

export const getParentAppFeatures = async () => {
  try {
    const response = await axios.get(ENDPOINTS.PARENT_APP_FEATURES.LIST);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createParentAppFeature = async (data) => {
  try {
    const response = await axios.post(ENDPOINTS.PARENT_APP_FEATURES.CREATE, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateParentAppFeature = async (featureKey, data) => {
  try {
    const response = await axios.put(
      `${ENDPOINTS.PARENT_APP_FEATURES.UPDATE}/${featureKey}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateOrgFeature = async (featureKey, organizationId, isEnabled) => {
  try {
    const response = await axios.put(
      `${ENDPOINTS.PARENT_APP_FEATURES.UPDATE}/${featureKey}`,
      { organization_id: organizationId, is_enabled: isEnabled }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStudentFeatures = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${baseURL}/api/student/features`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    return response;
  } catch (error) {
    throw error;
  }
};
